import React, { useState } from 'react';
import { formatCurrencyUnit, formatStat } from '../../utils/formatters';

export function PlatformCategoryBreakdown({ monthlyPlatformCategoryData }) {
  const [activePlatform, setActivePlatform] = useState('Google Ads');
  const [activeCategory, setActiveCategory] = useState('Performance');

  if (!monthlyPlatformCategoryData) {
    return <p className="text-xs text-gray-400 text-center py-4">No category data available</p>;
  }

  const platforms = ['Google Ads', 'Meta Ads'].filter(p => monthlyPlatformCategoryData[p]);
  const platformData = monthlyPlatformCategoryData[activePlatform];
  const categories = ['Performance', 'Branding'].filter(c => platformData?.[c]);
  const data = platformData?.[activeCategory];
  const months = data?.months || [];
  const totals = data?.totals || {};

  return (
    <div>
      <div className="flex gap-2 mb-2">
        {platforms.map(p => (
          <button key={p} onClick={() => setActivePlatform(p)}
            className={`pill-tab text-xs ${activePlatform === p ? 'pill-tab-active' : ''}`}>
            {p}
          </button>
        ))}
      </div>
      <div className="flex gap-2 mb-3">
        {categories.map(c => (
          <button key={c} onClick={() => setActiveCategory(c)}
            className={`text-xs px-3 py-1 rounded-full transition-colors ${activeCategory === c ? 'bg-gray-800 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
            {c}
          </button>
        ))}
      </div>
      <div className="overflow-x-auto">
        <table className="modern-table w-full">
          <thead>
            <tr>
              <th className="text-left">Month</th>
              <th className="text-right">Cost</th>
              <th className="text-right">Clicks</th>
              <th className="text-right">Conv.</th>
              <th className="text-right">Revenue</th>
              <th className="text-right">ROAS</th>
            </tr>
          </thead>
          <tbody>
            {months.map((m, i) => (
              <tr key={i}>
                <td className="text-xs font-medium text-gray-700 whitespace-nowrap">{m.month}</td>
                <td className="text-right text-xs">{formatCurrencyUnit(m.cost)}</td>
                <td className="text-right text-xs">{formatStat(m.clicks)}</td>
                <td className="text-right text-xs">{formatStat(m.conversions)}</td>
                <td className="text-right text-xs font-medium">{formatCurrencyUnit(m.revenue)}</td>
                <td className="text-right text-xs">{(m.roas || 0).toFixed(2)}x</td>
              </tr>
            ))}
            <tr className="font-bold bg-gray-50/50">
              <td className="text-xs font-bold">Total</td>
              <td className="text-right text-xs font-bold">{formatCurrencyUnit(totals.cost)}</td>
              <td className="text-right text-xs font-bold">{formatStat(totals.clicks)}</td>
              <td className="text-right text-xs font-bold">{formatStat(totals.conversions)}</td>
              <td className="text-right text-xs font-bold">{formatCurrencyUnit(totals.revenue)}</td>
              <td className="text-right text-xs font-bold">{(totals.roas || 0).toFixed(2)}x</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
